// @core/api/endpoints/calendar/list_calendar_event_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCalendarEventTypesResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List calendar event types
 * Returns all registered calendar event types, optionally filtered by product.
 */
export async function ListCalendarEventTypes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCalendarEventTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendar-event-types`;
  const requestOptions = options;
  return client.get<ListCalendarEventTypesResponse>(requestPath, { ...requestOptions, params });
}
